/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Description_3Inputs */

const bn_about_description_3 = /** @type {(inputs: About_Description_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`React, MUI এবং একটি টাইপ করা গেম লজিক লেয়ার দিয়ে তৈরি।`)
};

const de_about_description_3 = /** @type {(inputs: About_Description_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gebaut mit React, MUI und einer typisierten Spiellogikebene.`)
};

const el_about_description_3 = /** @type {(inputs: About_Description_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Κατασκευάστηκε με React, MUI και ένα πληκτρολογημένο επίπεδο λογικής παιχνιδιού.`)
};

const en_about_description_3 = /** @type {(inputs: About_Description_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Built with React, MUI, and a typed game logic layer.`)
};

const es_about_description_3 = /** @type {(inputs: About_Description_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Construido con React, MUI y una capa de lógica de juego escrita.`)
};

const fr_about_description_3 = /** @type {(inputs: About_Description_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Construit avec React, MUI et une couche de logique de jeu typée.`)
};

const hi_about_description_3 = /** @type {(inputs: About_Description_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रिएक्ट, एमयूआई और एक टाइप्ड गेम लॉजिक लेयर के साथ निर्मित।`)
};

const hu_about_description_3 = /** @type {(inputs: About_Description_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`React-tal, MUI-val és gépelt játéklogikai réteggel építve.`)
};

const id_about_description_3 = /** @type {(inputs: About_Description_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dibangun dengan React, MUI, dan lapisan logika permainan yang diketik.`)
};

const it_about_description_3 = /** @type {(inputs: About_Description_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Costruito con React, MUI e un livello di logica di gioco digitato.`)
};

const ja_about_description_3 = /** @type {(inputs: About_Description_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`React、MUI、および型付きゲーム ロジック レイヤーで構築されています。`)
};

const ko_about_description_3 = /** @type {(inputs: About_Description_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`React, MUI 및 형식화된 게임 로직 레이어로 구축되었습니다.`)
};

const nl_about_description_3 = /** @type {(inputs: About_Description_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gebouwd met React, MUI en een getypte spellogicalaag.`)
};

const pl_about_description_3 = /** @type {(inputs: About_Description_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zbudowany z React, MUI i typową warstwą logiki gry.`)
};

const pt_about_description_3 = /** @type {(inputs: About_Description_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Construído com React, MUI e uma camada lógica de jogo digitada.`)
};

const ru_about_description_3 = /** @type {(inputs: About_Description_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Построен с использованием React, MUI и уровня типизированной игровой логики.`)
};

const sv_about_description_3 = /** @type {(inputs: About_Description_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Byggd med React, MUI och ett maskinskrivet spellogiklager.`)
};

const tr_about_description_3 = /** @type {(inputs: About_Description_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`React, MUI ve yazılı oyun mantığı katmanıyla oluşturulmuştur.`)
};

const uk_about_description_3 = /** @type {(inputs: About_Description_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Створено з React, MUI та типізованого рівня ігрової логіки.`)
};

const vi_about_description_3 = /** @type {(inputs: About_Description_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Được xây dựng bằng React, MUI và lớp logic trò chơi được đánh máy.`)
};

const zh_about_description_3 = /** @type {(inputs: About_Description_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用 React、MUI 和类型化游戏逻辑层构建。`)
};

const zh_hant_about_description_3 = /** @type {(inputs: About_Description_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用 React、MUI 和類型化遊戲邏輯層建構。`)
};

/**
* | output |
* | --- |
* | "Built with React, MUI, and a typed game logic layer." |
*
* @param {About_Description_3Inputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const about_description_3 = /** @type {((inputs?: About_Description_3Inputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Description_3Inputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_about_description_3(inputs)
	if (locale === "de") return de_about_description_3(inputs)
	if (locale === "el") return el_about_description_3(inputs)
	if (locale === "en") return en_about_description_3(inputs)
	if (locale === "es") return es_about_description_3(inputs)
	if (locale === "fr") return fr_about_description_3(inputs)
	if (locale === "hi") return hi_about_description_3(inputs)
	if (locale === "hu") return hu_about_description_3(inputs)
	if (locale === "id") return id_about_description_3(inputs)
	if (locale === "it") return it_about_description_3(inputs)
	if (locale === "ja") return ja_about_description_3(inputs)
	if (locale === "ko") return ko_about_description_3(inputs)
	if (locale === "nl") return nl_about_description_3(inputs)
	if (locale === "pl") return pl_about_description_3(inputs)
	if (locale === "pt") return pt_about_description_3(inputs)
	if (locale === "ru") return ru_about_description_3(inputs)
	if (locale === "sv") return sv_about_description_3(inputs)
	if (locale === "tr") return tr_about_description_3(inputs)
	if (locale === "uk") return uk_about_description_3(inputs)
	if (locale === "vi") return vi_about_description_3(inputs)
	if (locale === "zh") return zh_about_description_3(inputs)
	return zh_hant_about_description_3(inputs)
});